
export const EXPTYPES = 'exptypes'




// WEBPACK FOOTER //
// ./src/store/modules/mutation_type.js